<template>
  <div>
    <router-view></router-view>
    <InstallPwaAlert />
  </div>
</template>

<script>
import InstallPwaAlert from "@/components/InstallPwaAlert.vue";

export default {
  name: "App",
  components: {
    InstallPwaAlert,
  },
};
</script>
